import AccountCardPrintProductConfigurationView from './AccountCardPrintProductConfigurationView';

export default AccountCardPrintProductConfigurationView;
